import { useState } from 'react'

import { F0Button } from '@factorialco/f0-react'
import { AvailableModules } from 'generated/featureDefinitions'
import { BillingAddonReferenceFragment, GetDatoModulesQuery } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { trackingEvents } from 'modules/core/lib/Tracking/events'
import { track } from 'modules/core/lib/Tracking/tracker'
import i18n from 'modules/core/lib/i18n'

import CheckoutModal from 'modules/upsell/components/SelfUpsell/CheckoutModal'
import { SelfUpsellProvider } from 'modules/upsell/store/SelfUpsellProvider'

type ModulesBillingAddonReference = NonNullable<
  NonNullable<
    NonNullable<
      GetDatoModulesQuery['modules']['datoModulesConnection']['nodes'][number]
    >['crossSellingBillingAddonReference']
  >[number]
>

type Props = {
  addonReference?: BillingAddonReferenceFragment[]
  crossSellingAddonReference?: ModulesBillingAddonReference[]
  mandatoryCrossSellingAddonReference?: ModulesBillingAddonReference[]
  moduleName: AvailableModules
  moduleSlug: string
}

const SelfUpsellSubscription = ({
  addonReference,
  crossSellingAddonReference,
  mandatoryCrossSellingAddonReference,
  moduleName,
  moduleSlug,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    track(trackingEvents.marketplaceModules.viewSelfUpsellButton, {
      module: moduleName,
      from: 'marketplace_header',
    })
  }, [])

  if (!addonReference) return null

  return (
    <SelfUpsellProvider
      availableAddons={addonReference}
      availableCrossSellingAddons={crossSellingAddonReference || []}
      availableMandatoryCrossSellingAddons={mandatoryCrossSellingAddonReference || []}
      availableOneTimeBillingCharges={[]}
      moduleName={moduleName}
    >
      <F0Button label={i18n.t('self_upsell.get_it_now')} onClick={() => setIsOpen(true)} />
      <CheckoutModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        moduleName={moduleName}
        moduleSlug={moduleSlug}
        from="marketplace_header"
      />
    </SelfUpsellProvider>
  )
}

export default SelfUpsellSubscription
